<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-header">
        <h3 v-if="mData.viewMode === 'create'">THÊM MỚI CÂU HỎI</h3>
        <h3 v-if="mData.viewMode === 'detail'">CHI TIẾT CÂU HỎI</h3>
        <h3 v-if="mData.viewMode === 'update'">CẬP NHẬT CÂU HỎI</h3>
      </div>

      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="validForm"
          ref="myForm"
          label-position="top"
        >
          <b-row>
            <b-col md="9">
              <el-form-item label="Tiêu đề" prop="tieu_de">
                <el-input
                  v-model="mData.dataForm.tieu_de"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  @input="forceUpdateUI"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Phân loại" prop="phan_loai">
                <el-select
                  v-model="mData.dataForm.phan_loai"
                  multiple
                  placeholder="Chọn phân loại"
                  :disabled="mData.viewMode === 'detail'"
                  clearable
                >
                  <el-option
                    v-for="item in mData.phanLoai"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <!-- <b-col md="5">
              <el-form-item label="Tags" prop="tags" class="tags">
                <vue-tags-input
                  v-model="tag"
                  :tags="tags"
                  @tags-changed="(newTags) => (tags = newTags)"
                  placeholder="Thêm tag"
                  :disabled="mData.viewMode == 'detail'"
                />
              </el-form-item>
            </b-col> -->
          </b-row>
          <b-row class="align-items-center">
            <b-col md="2">
              <el-form-item prop="hien_thi"
                ><el-checkbox
                  @change="fn_hienThiCauHoi"
                  :disabled="mData.viewMode == 'detail'"
                  v-model="mData.dataForm.hien_thi"
                  >Hiển thị câu hỏi</el-checkbox
                ></el-form-item
              >
            </b-col>
            <b-col md="2">
              <el-form-item
                v-if="mData.viewMode == 'detail' || mData.viewMode == 'update'"
                style="width: 200px"
                label-position="left"
              >
                <div class="d-flex align-items-center">
                  <label class="thu-tu-text">Thứ tự</label>
                  <el-select
                    v-model="mData.dataForm.thu_tu"
                    :disabled="mData.viewMode == 'detail'"
                    @change="forceUpdateUI"
                  >
                    <el-option
                      v-for="item in thu_tu_array"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item label="Tags" prop="tags" class="tags">
            <vue-tags-input
              v-model="tag"
              :tags="tags"
              @tags-changed="(newTags) => (tags = newTags)"
              placeholder="Thêm tag"
              :disabled="mData.viewMode == 'detail'"
            />
          </el-form-item>
          <br />
          <div class="label-s">
            <el-form-item label="Nội dung">
              <NoiDung
                :propDataEditor="mData.dataForm.noi_dung"
                @newData="fn_newData"
                :height="'580px'"
              ></NoiDung>
            </el-form-item>
          </div>
          <div class="text-center mt-3">
            <el-button
              type="danger"
              plain
              @click="fn_cancel()"
              v-ladda
              v-if="mData.viewMode === 'update' || mData.viewMode === 'create'"
              >hủy</el-button
            >
            <el-button
              type="primary"
              @click="fn_add()"
              v-ladda
              v-if="mData.viewMode === 'create'"
              >thêm mới</el-button
            >
            <el-button
              type="primary"
              @click="fn_update()"
              v-ladda
              v-if="mData.viewMode === 'update'"
              >cập nhật</el-button
            >
            <el-button
              type="primary"
              @click="fn_back()"
              v-ladda
              v-if="mData.viewMode === 'detail'"
              >quay lại</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import mushroom from "viettoc-api";
import ValidService from "../../../service/ValidService";
import MethodService from "../../../service/MethodService";
import DataForm from "../../../dataForm/dataFormCauHoiThuongGap";
import VueTagsInput from "@johmun/vue-tags-input";
import { Circle4 } from "vue-loading-spinner";
import NoiDung from "../../../component/EditorComponent.vue";
import LanguageService from "../../../service/LanguageService";
export default {
  components: {
    Circle4,
    VueTagsInput,
    NoiDung,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      loading: true,
      mData: {
        viewMode: "create",
        dataForm: MethodService.copyObject(DataForm.dataForm),
        tableRules: MethodService.copyObject(DataForm.tableRules),
        phanLoai: MethodService.copyObject(DataForm.phanLoai),
      },
      validForm: {
        tieu_de: [ValidService.required, ValidService.checkSpaceString],
        phan_loai: [ValidService.required, ValidService.requiredChange],
        noi_dung: [ValidService.required],
      },
      newData: "",
      total: "",
      thu_tu_array: [],
      thu_tu_current: "",
      tag: "",
      tags: [],
    };
  },
  methods: {
    // lấy số lượng tối đa câu hỏi để trường thu_tu tự động +1 khi tạo câu hỏi mới thành công
    async fn_getTotal() {
      try {
        const response = await mushroom.cau_hoi_thuong_gap.listAsync();
        this.total = response.meta.total;
        response.result.forEach((item) => {
          this.thu_tu_array.push({
            value: item.thu_tu,
            label: item.thu_tu,
          });
        });
        console.log("tổng câu hỏi:", this.total);
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async fn_initForm() {
      try {
        const response = await mushroom.cau_hoi_thuong_gap.listAsync({
          filters: ["id=" + this.$router.currentRoute.params.id],
          fields:
            "id,hien_thi,phan_loai,thu_tu,tags,tieu_de,noi_dung,thoi_diem_tao,thoi_diem_cap_nhat,nguoi_cap_nhat_id",
        });
        this.mData.dataForm = response.result[0];
        this.mData.dataForm.tieu_de = this.mData.dataForm.tieu_de.trim();
        this.thu_tu_current = response.result[0].thu_tu;
        this.loading = false;
        console.log("Câu hỏi:", this.mData.dataForm.phan_loai);
        console.log("response.result[0]", response.result[0]);
        if (response.result[0].tags) {
          response.result[0].tags.forEach((item) => {
            this.tags.push({ text: item, tiClasses: ["ti-valid"] });
          });
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    fn_hienThiCauHoi(event) {
      console.log(event);
      this.mData.dataForm.hien_thi = event;
    },

    fn_loaiChinhSach(event) {
      this.loaiChinhSach = event;
    },

    // thêm mới câu hỏi
    async fn_add() {
      const tagsArray = [];
      this.tags.forEach((item) => {
        tagsArray.push(item.text.toLowerCase());
      });
      const cau_hoi_object = {
        hien_thi: this.mData.dataForm.hien_thi,
        phan_loai: this.mData.dataForm.phan_loai,
        tieu_de: this.mData.dataForm.tieu_de,
        noi_dung: this.newData,
        tags: tagsArray,
        thu_tu: this.total + 1,
      };

      console.log("Câu hỏi:", cau_hoi_object);
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          console.log("cau_hoi_object", cau_hoi_object);
          if (cau_hoi_object.tieu_de.trim() == "") {
            window.toastr.warning("Tiêu đề không được để trống");
            MethodService.stopLadda();
          } else if (this.newData.trim() == "") {
            window.toastr.error("Phải nhập nội dung câu hỏi");
            MethodService.stopLadda();
          } else {
            try {
              await mushroom.cau_hoi_thuong_gap.createAsync(cau_hoi_object);
              MethodService.stopLadda();
              this.fn_resetForm();
              window.toastr.success("Thêm mới câu hỏi thành công");
              this.$router.push({
                name: "DanhSachCauHoi",
              });
            } catch (error) {
              console.error("Có lỗi: %o", error);
              MethodService.stopLadda();
              if (error.code === 4) {
                window.toastr.error(this.aLang.no_server);
              } else if (error.code === 2) {
                window.toastr.error("Gặp sự cố tải dữ liệu");
              } else {
                window.toastr.error("Đã có lỗi xảy ra");
              }
            }
          }
        } else MethodService.stopLadda();
      });
    },

    // cập nhật câu hỏi
    async fn_update() {
      const tagsArray = [];
      this.tags.forEach((item) => {
        tagsArray.push(item.text.toLowerCase());
      });
      const update_cau_hoi_object = {
        id: this.$router.currentRoute.params.id,
        hien_thi: this.mData.dataForm.hien_thi,
        phan_loai: this.mData.dataForm.phan_loai,
        tieu_de: this.mData.dataForm.tieu_de,
        noi_dung: this.newData,
        tags: tagsArray,
        thu_tu: this.mData.dataForm.thu_tu,
      };
      console.log("cập nhật chính sach", update_cau_hoi_object);
      if (
        this.mData.dataForm.tieu_de.trim() == "" ||
        this.mData.dataForm.tieu_de == ""
      ) {
        MethodService.stopLadda();
      } else if (this.mData.dataForm.phan_loai.length == 0) {
        window.toastr.warning("Giá trị phân loại không được để trống");
        MethodService.stopLadda();
      } else {
        try {
          // cập nhật thứ tự của câu hỏi bị lấy mất thứ tự
          const responseOld = await mushroom.cau_hoi_thuong_gap.listAsync({
            filters: ["thu_tu=" + this.mData.dataForm.thu_tu],
          });
          const object_old = {
            id: responseOld.result[0].id,
            thu_tu: this.mData.thu_tu_current,
          };
          await mushroom.cau_hoi_thuong_gap.partialUpdateAsync(object_old);

          // cập nhật thứ tự mới cho câu hỏi đang thao tác cập nhật
          const response = await mushroom.cau_hoi_thuong_gap.partialUpdateAsync(
            update_cau_hoi_object
          );
          if (response.result == this.$router.currentRoute.params.id) {
            window.toastr.success("Cập nhật câu hỏi thành công");
            MethodService.stopLadda();
            this.$router.push({
              name: "DanhSachCauHoi",
            });
          } else window.toastr.warning("Dữ liệu câu hỏi không thay đổi");
        } catch (error) {
          console.error("Có lỗi: %o", error);
          MethodService.stopLadda();
          if (error.code === 4) {
            window.toastr.error(this.aLang.no_server);
          } else if (error.code === 2) {
            window.toastr.error("Gặp sự cố tải dữ liệu");
          } else window.toastr.error("Đã có lỗi xảy ra");
        }
      }
    },

    // quay lại danh sách Cấu Hình
    fn_back() {
      this.$router.go(-1);
    },

    // reset form
    fn_resetForm() {
      this.$refs.myForm.$el.reset();
    },

    fn_cancel() {
      this.fn_resetForm();
      this.$router.go(-1);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    fn_newData(data) {
      this.newData = data;
    },
  },

  async created() {
    await this.fn_getTotal();
    // kiểm tra loại viewMode
    console.log(this.$router.currentRoute.name);
    if (this.$router.currentRoute.name == "ThemMoiCauHoi") {
      this.mData.viewMode = "create";
      this.loading = false;
    }
    if (this.$router.currentRoute.name == "ChiTietCauHoi") {
      this.mData.viewMode = "detail";
      await this.fn_initForm();
    }
    if (this.$router.currentRoute.name == "CapNhatCauHoi") {
      this.mData.viewMode = "update";
      await this.fn_initForm();
    }
  },
};
</script>

<style lang="scss" scoped>
.thu-tu-text {
  width: 90px;
  color: #64666a;
}
::v-deep .label-s label::after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
  font-weight: bold;
}
::v-deep .ti-input {
  border-radius: 3px;
  // height: 32px;
}
::v-deep .vue-tags-input {
  max-width: 100% !important;
}
</style>
